module.exports = __webpack_public_path__ + "img/img12.510d7677.svg";